import Services from '../Service'

class AdminLogService extends Services {
  constructor() {
    super()
    this.resource = 'admin/logs'
  }

  async getLogs(params) {
    return await this.getAPI(this.resource, params)
  }
}

export default new AdminLogService()
